import gql from 'graphql-tag';

export const GET_ALL_APPLICATIONCONFIGURATION = gql(`
query($maxregs: Int) {
    applicationConfigurationQuery {
      getAll(maxregs:$maxregs) {
            applicationId,
            applicationVersion,
            idKeyType,
            keyValue,
            keyBinaryValue,
            order,
            fcr,
            ucr,
            uum,
            fum
      }
    }
}
`);


export const GET_APPLICATION_BY_ID = gql(`
query( $applicationId: Int!, $version: Int!) {
  applicationConfigurationQuery {
    getByApplicationId(applicationId:$applicationId, version:$version) {
            applicationId,
            applicationVersion,
            idKeyType,
            keyValue,
            keyBinaryValue,
            order,
            fcr,
            ucr,
            uum,
            fum
      }
    }
}
`);




